<template>
  <div>
    <el-row :gutter="10" style="margin: 10px 0px">
      <el-col :xs="24" :lg="6" style="padding: 6px 0">
        <span style="width: 75px"> 企业类型： </span>
        <el-select
          v-model="companyNature"
          placeholder="请选择"
          clearable
          size="mini"
        >
          <el-option label="国有" value="国有"></el-option>
          <el-option label="民营" value="民营"></el-option>
          <el-option label="外资" value="外资"></el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :lg="6" style="padding: 6px 0">
        <span style="width: 75px"> 行业代码： </span>
        <el-select
          v-model="industry_type"
          placeholder="请选择"
          clearable
          size="mini"
        >
          <el-option
            v-for="item in industryList"
            :key="item.id"
            :label="item.name"
            :value="item.name"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :lg="6" style="padding: 6px 0">
        <span style="width: 75px"> 企业名称： </span>
        <el-input
          v-model="companyName"
          style="width: 212px"
          size="mini"
        ></el-input>
      </el-col>
      <el-col :xs="24" :lg="6" style="padding: 6px 0 0">
        <span style="width: 75px"> 企业注册类型： </span>
        <el-select
          v-model="registerType"
          placeholder="请选择"
          clearable
          size="mini"
        >
          <el-option
            v-for="item in registerList"
            :key="item.id"
            :label="item.name"
            :value="item.name"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row :gutter="10" style="margin: 10px 0px">
      <el-col :xs="24" :lg="6" style="padding: 0px 0 6px">
        <span style="width: 75px"> 数据类型： </span>
        <el-select v-model="dataRange" placeholder="请选择" size="mini">
          <el-option
            v-for="item in dataRangeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col
        :xs="24"
        :lg="6"
        style="padding: 6px 0"
        v-if="dataRange === 'month'"
      >
        <span style="margin-left: 24px"> 时间： </span>
        <el-date-picker
          class="jiance_phone_date"
          :editable="false"
          :clearable="false"
          v-model="times"
          type="month"
          size="mini"
          value-format="yyyy-MM"
          :picker-options="pickerOptions"
          placeholder="选择月"
        >
        </el-date-picker>
      </el-col>
      <el-col
        :xs="24"
        :lg="6"
        style="padding: 6px 0"
        v-if="dataRange === 'quarter'"
      >
        <span>
          <quarter
            style="margin-left: 28px"
            :default-value="defaultQuarterValue"
            v-on:getQuarter="getQuarter"
          ></quarter>
        </span>
      </el-col>
      <el-col
        :xs="24"
        :lg="6"
        style="padding: 6px 0"
        v-if="dataRange === 'year'"
      >
        <span style="margin-left: 28px"> 时间： </span>
        <el-date-picker
          class="jiance_phone_date"
          :editable="false"
          :clearable="false"
          type="year"
          v-model="year"
          size="mini"
          value-format="yyyy"
          :picker-options="pickerOptions"
          placeholder="选择年"
        >
        </el-date-picker>
      </el-col>
      <el-col :xs="24" :lg="6" style="padding: 6px 0">
        <span style="margin-left: 24px"> 单位： </span>
        <el-select
          v-model="unit"
          placeholder="请选择"
          @change="unitChange"
          size="mini"
        >
          <el-option label="亿元" value="0.00001"></el-option>
          <el-option label="万元" value="0.1"></el-option>
          <el-option label="千元" value="1"></el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :lg="6">
        <div class="phone_button_box">
          <el-button type="primary" @click="initData">查询</el-button>
          <el-button type="info" @click="onReset">重置</el-button>
        </div>
      </el-col>
    </el-row>
    <el-link style="margin: 10px 0px" type="primary" @click="exportData">{{
      exportLabel
    }}</el-link>
    <el-row style="margin: 10px 0px">
      <el-col :span="24">
        <el-table
          v-loading="loading"
          border
          :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
          stripe
          :data="tableData"
        >
          <el-table-column type="index" label="序号" fixed width="50">
          </el-table-column>
          <el-table-column prop="NAME" fixed label="企业"> </el-table-column>
          <el-table-column :label="`工业总产值${unitStr}`">
            <el-table-column
              sortable
              :formatter="handelFix2"
              min-width="100"
              prop="this_month_gyzcz"
              label="当期"
            >
            </el-table-column>
            <el-table-column
              sortable
              min-width="120"
              :formatter="handelFix2"
              prop="last_year_month_gyzcz"
              label="上年同期"
            >
            </el-table-column>
            <el-table-column
              sortable
              :formatter="handelFix1"
              min-width="120"
              prop="gyzczRate"
              label="同比增速(%)"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column :label="`工业销售产值${unitStr}`">
            <el-table-column
              sortable
              :formatter="handelFix2"
              min-width="100"
              prop="this_month_gyxscz"
              label="当期"
            >
            </el-table-column>
            <el-table-column
              sortable
              :formatter="handelFix2"
              min-width="120"
              prop="last_year_month_gyxscz"
              label="上年同期"
            >
            </el-table-column>
            <el-table-column
              sortable
              prop="gyxsczRate"
              :formatter="handelFix1"
              min-width="120"
              label="同比增速(%)"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column :label="`营业收入${unitStr}`">
            <el-table-column
              sortable
              prop="this_month_yysr"
              min-width="100"
              :formatter="handelFix2"
              label="当期"
            >
            </el-table-column>
            <el-table-column
              sortable
              prop="last_year_month_yysr"
              min-width="120"
              :formatter="handelFix2"
              label="上年同期"
            >
            </el-table-column>
            <el-table-column
              prop="yysrRate"
              sortable
              min-width="120"
              :formatter="handelFix1"
              label="同比增速(%)"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column :label="`利润总额${unitStr}`">
            <el-table-column
              sortable
              prop="this_month_lrze"
              min-width="100"
              :formatter="handelFix2"
              label="当期"
            >
            </el-table-column>
            <el-table-column
              sortable
              prop="last_year_month_lrze"
              min-width="120"
              :formatter="handelFix2"
              label="上年同期"
            >
            </el-table-column>
            <el-table-column
              prop="lrzeRate"
              sortable
              min-width="120"
              :formatter="handelFix1"
              label="同比增速(%)"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column :label="`营业税金及附加${unitStr}`">
            <el-table-column
              prop="this_month_yysj"
              min-width="100"
              sortable
              :formatter="handelFix2"
              label="当期"
            >
            </el-table-column>
            <el-table-column
              prop="last_year_month_yysj"
              :formatter="handelFix2"
              min-width="120"
              sortable
              label="上年同期"
            >
            </el-table-column>
            <el-table-column
              prop="yysjRate"
              min-width="120"
              :formatter="handelFix1"
              sortable
              label="同比增速(%)"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column :label="`应缴增值税${unitStr}`">
            <el-table-column
              prop="this_month_zzs"
              :formatter="handelFix2"
              min-width="100"
              sortable
              label="当期"
            >
            </el-table-column>
            <el-table-column
              prop="last_year_month_zzs"
              :formatter="handelFix2"
              min-width="120"
              sortable
              label="上年同期"
            >
            </el-table-column>
            <el-table-column
              prop="zzsRate"
              min-width="120"
              :formatter="handelFix1"
              sortable
              label="同比增速(%)"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="企业用电量（万千瓦时）">
            <el-table-column
              prop="this_month_qyydl"
              sortable
              min-width="100"
              :formatter="handelFix2"
              label="当期"
            >
            </el-table-column>
            <el-table-column
              prop="last_year_month_qyydl"
              sortable
              min-width="120"
              :formatter="handelFix2"
              label="上年同期"
            >
            </el-table-column>
            <el-table-column
              prop="qyydlRate"
              sortable
              min-width="120"
              :formatter="handelFix1"
              label="同比增速(%)"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column fixed="right" label="企业表" width="60">
            <template slot-scope="scope">
              <el-button
                @click="handleClick(scope.row, '001')"
                type="text"
                size="small"
                >产值表</el-button
              >
              <el-button
                style="margin-left: 0"
                @click="handleClick(scope.row, '002')"
                type="text"
                size="small"
                >财务表</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="pageBox">
      <el-pagination
        class="pagePC"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="20"
        layout="total,  prev, pager, next"
        :total="total"
      >
      </el-pagination>
      <van-pagination
        class="pagePhone"
        v-model="currentPage"
        :total-items="total"
        :items-per-page="20"
        :show-page-size="3"
        @change="changePage"
        force-ellipses
      />
    </div>
    <el-dialog
      v-if="showDialogVisible"
      title="查看"
      append-to-body
      :visible.sync="showDialogVisible"
      class="dialog770 titleChange"
      :width="screenWidth < 1200 ? '96%' : '1160px'"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <zdquczbShow v-if="editCode == '001'" :id="editId"></zdquczbShow>
      <zdjcqycwbShow v-if="editCode == '002'" :id="editId"></zdjcqycwbShow>
    </el-dialog>
  </div>
</template>
<script>
import quarter from "@/components/dateUtils/quarter.vue";
import zdquczbShow from "@/views/Index/Workbench/DataCollection/DataWrite/notInsert/zdquczbShow/index";
import zdjcqycwbShow from "@/views/Index/Workbench/DataCollection/DataWrite/notInsert/zdjcqycwbShow/index";
import { export2Excel } from "@/utils/utils";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    regionCodeDef: {
      type: String,
      default: "",
    },
    industryTypeDef: {
      type: String,
      default: "",
    },
    companyNatureDef: {
      type: String,
      default: "",
    },
    registerTypeDef: {
      type: String,
      default: "",
    },
    dataRangeDef: {
      type: String,
      default: "",
    },
    timesDef: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      screenWidth: document.body.clientWidth, // 屏幕宽
      screeHeight: document.body.clientHeight, // 屏幕高
      loading: false,
      showDialogVisible: false,
      editCode: "",
      editId: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      exportLabel: "<<点击此处可导出报表",
      showArea: false,
      areaName: "",
      industry_type: this.industryTypeDef,
      companyNature: this.companyNatureDef,
      companyName: "",
      registerType: this.registerTypeDef,
      unit: "1",
      unitStr: "（千元）",
      currentPage: 1,
      total: 1,
      page: 1,
      pageSize: 20,
      srcDataList: [],
      industryList: [],
      registerList: [],
      dialogTableVisible: false,
      queryData: {},
      dataIndexOptions: [
        {
          value: "gyzjz",
          label: "工业增加值",
        },
        {
          value: "yysr",
          label: "营业收入",
        },
        {
          value: "lrze",
          label: "利润总额",
        },
      ],
      dataRangeOptions: [
        {
          value: "month",
          label: "月度",
        },
        {
          value: "quarter",
          label: "季度",
        },
        {
          value: "year",
          label: "年度",
        },
      ],
      dataRange: this.dataRangeDef || "month", //数据类型
      times: this.timesDef, //时间
      year: "", //时间
      yearDef: "", //时间
      quarter: "", //时间
      quarterDef: "", //时间
      defaultQuarterValue: [], //时间
      defaultMonthValue: "", //时间
      QuarterValue: [],
      tableData: [],
    };
  },
  components: {
    quarter,
    zdquczbShow,
    zdjcqycwbShow,
  },
  methods: {
    changePage() {
      this.page = this.currentPage;
      this.initData();
    },
    handelFix1(row, column) {
      if (row[column.property] && !isNaN(row[column.property])) {
        return row[column.property].toFixed(1);
      } else {
        return row[column.property];
      }
    },
    handelFix2(row, column) {
      if (row[column.property] && !isNaN(row[column.property])) {
        return row[column.property].toFixed(2);
      } else {
        return row[column.property];
      }
    },
    unitChange(value) {
      if (value === "1") {
        this.unitStr = "（千元）";
      } else if (value === "0.1") {
        this.unitStr = "（万元）";
      } else if (value === "0.00001") {
        this.unitStr = "（亿元）";
      }
      this.getShowData();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.initData();
    },
    handleCurrentChange(val) {
      //跳转页
      console.log(`当前页: ${val}`);
      this.page = val;
      this.initData();
    },
    getSelectList() {
      //获取下拉列表
      // 国民经济行业列表
      this.$axios.get("/business/project/industry").then((res) => {
        this.industryList = res.data;
      });
      // 登记注册类型
      this.$axios.get("/business/company/selectRegisterType").then((res) => {
        this.registerList = res.data;
      });
    },
    onReset() {
      this.companyName = "";
      this.companyNature = this.companyNatureDef;
      this.industry_type = this.industryTypeDef;
      this.registerType = this.registerTypeDef;
      this.unit = "1";
      this.unitStr = "（千元）";
      this.times = this.timesDef;
      this.year = this.yearDef;
      this.quarter = this.quarterDef;
      this.dataRange = this.dataRangeDef || "month";
      delete this.queryData.companyName;
      delete this.queryData.industry_type;
      delete this.queryData.companyNature;
      delete this.queryData.registerType;
      this.initData();
    },
    initData() {
      const self = this;
      this.loading = true;
      if (this.companyName) {
        this.queryData.companyName = this.companyName;
      }
      if (this.industry_type) {
        this.queryData.industry_type = this.industry_type;
      }
      if (this.companyNature) {
        this.queryData.companyNature = this.companyNature;
      }
      if (this.registerType) {
        this.queryData.registerType = this.registerType;
      }
      this.queryData.dateType = this.dataRange;
      this.queryData.month = this.times;
      this.queryData.year = this.year;
      this.queryData.quarter = this.quarter;
      this.queryData.page = this.page;
      this.queryData.pageSize = this.pageSize;
      this.$axios
        .post("/business/companyMonitor/queryByCompany1", this.queryData)
        .then((res) => {
          this.tableData = [];
          this.srcDataList = res.data;
          this.total = res.total;
          this.getShowData();
          this.loading = false;
        });
    },
    disabledDate(time) {
      return time.getTime() > Date.now();
    },
    handleClick(row, type) {
      this.editCode = type;
      if (type === "001") {
        this.editId = row.czbId;
      } else {
        this.editId = row.cwbId;
      }
      console.log(this.editCode, this.editId, row);
      this.showDialogVisible = true;
    },
    getQuarter(value) {
      this.year = value.slice(0, 4);
      const tmp = value.slice(5, 7);
      if (tmp === "01") {
        this.quarter = 1;
      } else if (tmp === "04") {
        this.quarter = 2;
      } else if (tmp === "07") {
        this.quarter = 3;
      } else if (tmp === "10") {
        this.quarter = 4;
      }
      this.initData();
    },
    getShowData() {
      this.tableData = [];
      this.srcDataList.forEach((item) => {
        const obj = {
          NAME: item.NAME,
          czbId: item.czbId,
          cwbId: item.cwbId,
        };
        obj.this_month_gyzcz = item.this_month_gyzcz * this.unit;
        obj.last_year_month_gyzcz = item.last_year_month_gyzcz * this.unit;
        obj.this_month_yysr = item.this_month_yysr * this.unit;
        obj.last_year_month_yysr = item.last_year_month_yysr * this.unit;
        obj.this_month_yysj = item.this_month_yysj * this.unit;
        obj.last_year_month_yysj = item.last_year_month_yysj * this.unit;
        obj.this_month_lrze = item.this_month_lrze * this.unit;
        obj.last_year_month_lrze = item.last_year_month_lrze * this.unit;
        obj.this_month_zzs = item.this_month_zzs * this.unit;
        obj.last_year_month_zzs = item.last_year_month_zzs * this.unit;
        obj.this_month_gyxscz = item.this_month_gyxscz * this.unit;
        obj.last_year_month_gyxscz = item.last_year_month_gyxscz * this.unit;
        obj.this_month_qyydl = item.this_month_qyydl;
        obj.last_year_month_qyydl = item.last_year_month_qyydl;
        obj.gyzczRate =
          item.last_year_month_gyzcz > 0
            ? ((item.this_month_gyzcz - item.last_year_month_gyzcz) /
                item.last_year_month_gyzcz) *
              100
            : "--";
        obj.yysrRate =
          item.last_year_month_yysr > 0
            ? ((item.this_month_yysr - item.last_year_month_yysr) /
                item.last_year_month_yysr) *
              100
            : "--";
        obj.yysjRate =
          item.last_year_month_yysj > 0
            ? ((item.this_month_yysj - item.last_year_month_yysj) /
                item.last_year_month_yysj) *
              100
            : "--";
        obj.lrzeRate =
          item.last_year_month_lrze > 0
            ? ((item.this_month_lrze - item.last_year_month_lrze) /
                item.last_year_month_lrze) *
              100
            : "--";
        obj.zzsRate =
          item.last_year_month_zzs > 0
            ? ((item.this_month_zzs - item.last_year_month_zzs) /
                item.last_year_month_zzs) *
              100
            : "--";
        obj.gyxsczRate =
          item.last_year_month_gyxscz > 0
            ? ((item.this_month_gyxscz - item.last_year_month_gyxscz) /
                item.last_year_month_gyxscz) *
              100
            : "--";
        obj.qyydlRate =
          item.last_year_month_qyydl > 0
            ? ((item.this_month_qyydl - item.last_year_month_qyydl) /
                item.last_year_month_qyydl) *
              100
            : "--";
        this.tableData.push(obj);
      });
    },
    changeDataIndex(value) {
      this.$emit("changeDataIndex", value);
      this.getShowData();
    },
    getNowQuarter() {
      if (!this.timesDef) {
        const today = new Date();
        const month = today.getMonth() + 1; //getMonth返回0-11
        const year = today.getFullYear(); //getMonth返回0-11
        this.year = year;
        if (month < 10) {
          this.times = year + "-0" + month;
        } else {
          this.times = year + "-" + month;
        }
      }
      //下面是几个if
      let year = this.times.slice(0, 4);
      this.year = year;
      this.yearDef = year;
      const month = parseInt(this.times.split("-").pop());
      //下面是几个if
      if (month >= 1 && month <= 3) {
        this.quarter = 1;
        this.quarterDef = 1;
        return year + "-" + "01" + "," + year + "-" + "03";
      } else if (month >= 4 && month <= 6) {
        this.quarter = 2;
        this.quarterDef = 2;
        return year + "-" + "04" + "," + year + "-" + "06";
      } else if (month >= 7 && month <= 9) {
        this.quarter = 3;
        this.quarterDef = 3;
        return year + "-" + "07" + "," + year + "-" + "09";
      } else if (month >= 10 && month <= 12) {
        this.quarter = 4;
        this.quarterDef = 4;
        return year + "-" + "10" + "," + year + "-" + "12";
      }
      this.quarterDef = this.quarter;
    },
    exportData() {
      const column = [
        {
          title: "企业",
          key: "NAME",
          rowspan: 2,
        },
        {
          title: "工业总产值" + this.unitStr,
          data: [
            {
              title: "当期",
              toFixed: 2,
              key: "this_month_gyzcz",
            },
            {
              title: "上年同期",
              toFixed: 2,
              key: "last_year_month_gyzcz",
            },
            {
              title: "同比增速(%)",
              toFixed: 1,
              key: "gyzczRate",
            },
          ],
          colspan: 3,
        },
        {
          title: "工业销售产值" + this.unitStr,
          data: [
            {
              title: "当期",
              toFixed: 2,
              key: "this_month_gyxscz",
            },
            {
              title: "上年同期",
              toFixed: 2,
              key: "last_year_month_gyxscz",
            },
            {
              title: "同比增速(%)",
              toFixed: 1,
              key: "gyxsczRate",
            },
          ],
          colspan: 3,
        },
        {
          title: "营业收入" + this.unitStr,
          data: [
            {
              title: "当期",
              toFixed: 2,
              key: "this_month_yysr",
            },
            {
              title: "上年同期",
              toFixed: 2,
              key: "last_year_month_yysr",
            },
            {
              title: "同比增速(%)",
              toFixed: 1,
              key: "yysrRate",
            },
          ],
          colspan: 3,
        },
        {
          title: "利润总额" + this.unitStr,
          data: [
            {
              title: "当期",
              toFixed: 2,
              key: "this_month_lrze",
            },
            {
              title: "上年同期",
              toFixed: 2,
              key: "last_year_month_lrze",
            },
            {
              title: "同比增速(%)",
              toFixed: 1,
              key: "lrzeRate",
            },
          ],
          colspan: 3,
        },
        {
          title: "营业税金及附加" + this.unitStr,
          data: [
            {
              title: "当期",
              toFixed: 2,
              key: "this_month_yysj",
            },
            {
              title: "上年同期",
              toFixed: 2,
              key: "last_year_month_yysj",
            },
            {
              title: "同比增速(%)",
              toFixed: 1,
              key: "yysjRate",
            },
          ],
          colspan: 3,
        },
        {
          title: "应缴增值税" + this.unitStr,
          data: [
            {
              title: "当期",
              toFixed: 2,
              key: "this_month_zzs",
            },
            {
              title: "上年同期",
              toFixed: 2,
              key: "last_year_month_zzs",
            },
            {
              title: "同比增速(%)",
              toFixed: 1,
              key: "zzsRate",
            },
          ],
          colspan: 3,
        },
        {
          title: "企业用电量（万千瓦时）",
          data: [
            {
              title: "当期",
              toFixed: 2,
              key: "this_month_qyydl",
            },
            {
              title: "上年同期",
              toFixed: 2,
              key: "last_year_month_qyydl",
            },
            {
              title: "同比增速(%)",
              toFixed: 1,
              key: "qyydlRate",
            },
          ],
          colspan: 3,
        },
      ];
      let timeStr = "";
      if (this.dataRange === "year") {
        timeStr = this.year + "年";
      } else if (this.dataRange === "quarter") {
        timeStr = this.year + "年第" + this.quarter + "季度";
      } else {
        timeStr = this.times.slice(0, 4) + "年" + this.times.slice(5, 7) + "月";
      }
      console.log(this.tableData);
      export2Excel(column, this.tableData, this.title + "_" + timeStr);
    },
  },
  created() {
    this.defaultQuarterValue = this.getNowQuarter();
    this.getSelectList();
    this.initData();
    if (this.regionCodeDef) {
      this.queryData.region = this.regionCodeDef;
    } else if (this.registerTypeDef) {
      this.queryData.registerType = this.registerTypeDef;
    } else if (this.industryTypeDef) {
      this.queryData.industry_type = this.industryTypeDef;
    } else if (this.companyNatureDef) {
      this.queryData.companyNature = this.companyNatureDef;
    }
  },
  mounted() {
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
  },
};
</script>
<style lang="less" scoped>
.pagePhone {
  display: none;
}
@media (max-width: 1200px) {
  .phone_button_box {
    display: block;
    width: 150px;
    margin: 20px auto;
  }
  .pagePC {
    display: none;
  }
  .pagePhone {
    display: flex;
  }
}
</style>
